
import '../App.css';
import React, { useState, useEffect, useRef } from 'react';
import logo from '../logo.png'
import { useNavigate } from 'react-router-dom';
import moment from 'moment/moment';
import { FaFolder, FaUserFriends } from "react-icons/fa";
import { FaUserTie } from "react-icons/fa";
import ReactModal from 'react-modal';
//import { toast } from 'wc-toast'
import Select, { components } from 'react-select';
import { add_icon, add_image, add_video, delete_icon, view_icon } from '../assets/Icons';
import { IoIosCloseCircle, IoMdCloseCircleOutline } from "react-icons/io";
import { db, storage } from '../config';
import { decrypt, encrypt } from '../Crypto';
import { MdAddPhotoAlternate } from "react-icons/md";
import { RiEditFill, RiVideoAddFill } from "react-icons/ri";
import { FaRegFolderClosed } from "react-icons/fa6";
import { FaFolderClosed } from "react-icons/fa6";
import { RiImageAddLine } from "react-icons/ri";
import { Levels } from 'react-activity';
import { TbTopologyStar2 } from "react-icons/tb";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import "react-activity/dist/library.css";
//import { ToastContainer, toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.css';
import { Modal } from 'react-responsive-modal';
import Collapsible from 'react-collapsible';
import { connect } from 'react-redux';
import { SetId } from './redux/actions';
//import "react-responsive-modal/styles.css";
import { Typewriter } from 'react-simple-typewriter'
import { GoLinkExternal } from 'react-icons/go';
import { VscThreeBars } from 'react-icons/vsc';
import BackDrop from './Backdrop';
import { toast } from 'wc-toast';

import { Collapse } from "react-collapse";
import { FiImage, FiClock, FiSettings } from "react-icons/fi";

const userdb = db.ref('userdb');



const recruiter_active = <FaUserTie color='white' size={22} />
const recruiter_active_non = <FaUserTie color='#B9B9B9' size={22} />

const room = db.ref('Sign_up')

function Content({ items, SetId }) {

    // ✅ 3) One-line titles in mobile drawer
    const mobileDrawerTitleStyle = (maxW) => ({
        color: "white",
        marginLeft: 18,
        fontWeight: "600",
        fontSize: 15,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: maxW,
        display: "block",
    });

    const key = items.myid == null ? null : items.myid.id

    console.log('Key...........', key)


    const [aiOpen, setAiOpen] = useState(false);

    const AiSubItem = ({ icon, label, onClick }) => (
        <div
            onClick={onClick}
            style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 14,
                height: 52,
                paddingLeft: 18,
                paddingRight: 20,
                marginBottom: 8,
                borderRadius: 12,
                backgroundColor: "transparent",
            }}
        >
            <div
                style={{
                    width: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#9AA4B2",
                }}
            >
                {icon}
            </div>

            <span
                style={{
                    fontSize: label === "Create Images" ? 13 : 15,
                    fontWeight: 600,
                    lineHeight: "1",
                    color: "#9AA4B2",
                    textAlign: "left",
                    whiteSpace: "nowrap",
                }}
            >
                {label}
            </span>
        </div>
    );

    const AiLeftSubMenuDesktop = () => {
        return (
            <div
                style={{
                    display: "flex",
                    width: width * 0.14,
                    //  alignSelf: "center",
                    marginTop: 8,
                    // justifyContent: "center", // center whole block
                    marginLeft: 52,
                }}
            >
                {/* inner aligned block */}

                {/* vertical line */}
                <div
                    style={{
                        width: 4,
                        backgroundColor: "#2E3642",
                        borderRadius: 4,
                        marginRight: 14,
                    }}
                />

                {/* menu items */}
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start", // text stays left aligned
                    }}
                >
                    <AiSubItem
                        icon={<FiImage />}
                        label="Create Images"
                        onClick={() => {
                            if (items.devices > 0) {
                                navigate("/AICreate")
                                // Do something if devices are available
                            }
                            else toast('Add a Boom Display Device before using Ai')
                        }}
                    />

                    <AiSubItem
                        icon={<FiClock />}
                        label="History"
                        onClick={() => navigate("/AIGenerator")}
                    />

                    <AiSubItem
                        icon={<FiSettings />}
                        label="Settings"
                        onClick={() => navigate("/AISetting")}
                    />
                </div>


            </div>
        );
    };


    const AiLeftSubMenuMobile = () => {
        return (
            <div
                style={{
                    display: "flex",
                    width: width * 0.35,
                    alignSelf: "center",
                    marginTop: 8,
                }}
            >
                {/* vertical line */}
                <div
                    style={{
                        width: 4,
                        backgroundColor: "#2E3642",
                        borderRadius: 4,
                        marginRight: 14,
                        marginLeft: 12,
                    }}
                />

                <div style={{ flex: 1 }}>
                    <AiSubItem
                        icon={<FiImage />}
                        label="Create Images"
                        onClick={() => navigate("/AICreate")}
                    />

                    <AiSubItem
                        icon={<FiClock />}
                        label="History"
                        onClick={() => navigate("/AIGenerator")}
                    />

                    <AiSubItem
                        icon={<FiSettings />}
                        label="Settings"
                        onClick={() => navigate("/AISetting")}
                    />
                </div>
            </div>
        );
    };



    const [edit_content_name, setEditContentName] = useState(null)



    useEffect(() => {
        if (items.myid == null) {
            let obj = localStorage.getItem('display')
            if (obj != null) { obj = JSON.parse(obj); SetId(obj) }
            else { navigate('/') }
        }
    }, [items])

    let curr = new Date().getTime();
    let seven_back = new Date(moment(new Date(curr)).subtract(8, 'days').format("MM/DD/YYYY")).getTime()
    let one_back = new Date(moment(new Date(curr)).subtract(1, 'days').format("MM/DD/YYYY")).getTime()

    const navigate = useNavigate();


    const [touched1, setTouched1] = useState(false);
    const [password_pop_up, setPasswordPopUp] = useState(true);

    function toggleTouched1() {
        setTouched1(!touched1);
    }

    function handleMouseUp1() {
        // Handle smooth animation when clicking without holding
        setTimeout(() => {
            setTouched1(!touched1);
        }, 150);
    }

    const [addImage, setAddImage] = useState(false)
    const [addVideo, setAddVideo] = useState(false)
    const [addFolder, setAddFolder] = useState(false)
    const [editFolder, setEditFolder] = useState(false)

    const [mycontent, setMycontent] = useState([])

    const [picture, setPicture] = useState(null)
    const [imguri, setimguri] = useState(null)

    const [upload_name, setUploadName] = useState('')

    const [loading, setLoading] = useState(null)

    const [id, setId] = useState('')

    const [name, setName] = useState('')

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

    useEffect(() => {
        const subscribe = userdb.child(String(key)).child('content').on('value', (snapshot) => {
            if (snapshot != undefined && snapshot.val() != null) {
                let arr = Object.values(snapshot.val());
                setMycontent([...arr])
            }
        })
        return () => subscribe()
    }, [key])

    const uploadImage = async () => {

        if (imguri != null && name != '' && selectedOption != null) {

            let snap = await userdb.child(String(key)).child('content').orderByChild('name').equalTo(encrypt(name)).once('value')

            if (snap.val() == null) {

                const obj = {
                    ID: new Date().getTime(),
                    uri: null,
                    name: encrypt(name),
                    type: 'image',
                    upload: encrypt(imguri.name),
                    folder: selectedOption
                }

                setLoading(true)
                toast('Please wait for confirmation message !');
                const uploadTask = storage.ref(`/images/${key}/${obj.ID}`).put(imguri);
                uploadTask.on('state_changed', snapshot => {
                    const progress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    // if (progress == 100) (setLoading(false));
                }, (error) => {
                    // Handle unsuccessful uploads
                    alert('error uploading image')
                }, () => {
                    storage.ref(`/images/${key}/${obj.ID}`).getDownloadURL().then((downloadURL) => {
                        obj.uri = downloadURL
                        userdb.child(String(key)).child('content').child(String(obj.ID)).set(obj).then(() => {
                            setLoading(false)
                            setimguri(null)
                            setName('')
                            setAddImage(false)
                            setPicture(null)
                            setSelectedOption(null)
                            toast('Photo has been updated')
                        })
                    });

                })
                try {
                    await uploadTask;
                } catch (e) {
                    console.error(e);
                }
            }
            else toast('This name already exists !')
        }
        else toast('Please fill out all the required fields.')

    };

    const [my_folders, setMyFolders] = useState([])

    const [show_folders, setShowFolders] = useState([])
    const [search_folder, setSearchFolder] = useState('')
    const [search_content, setSearchContent] = useState('')

    useEffect(() => {
        const subscribe = userdb.child(String(key)).child('folder').on('value', (snapshot) => {
            if (snapshot != undefined && snapshot.val() != null) {
                let arr = Object.values(snapshot.val());
                for (let i = 0; i < arr.length; i++) {
                    arr[i].name = decrypt(arr[i].name)
                    arr[i].value = arr[i].name
                    arr[i].label = arr[i].name
                }
                setMyFolders([...arr])
            }
            else setMyFolders([])
        })
        return () => subscribe()
    }, [key])

    async function EditContentName() {
        let snap = await userdb.child(String(key)).child('content').orderByChild('name').equalTo(encrypt(name)).once('value')

        if (snap.val() == null) {
            await userdb.child(String(key)).child('content').child(String(edit_content_name.ID)).update({ name: encrypt(name) })
            setName('')
            setEditContentName(null)
        }
        else {
            toast('This name already exists !')
        }
    }

    async function EditFolderFunction() {
        const obj = {
            ID: editFolder.ID,
            name: encrypt(name),
        }
        let snap = await userdb.child(String(key)).child('folder').orderByChild('name').equalTo(encrypt(name)).once('value')
        if (snap.val() == null) {
            await userdb.child(String(key)).child('folder').child(String(obj.ID)).update(obj)
            toast('Folder has been created')
            setEditFolder(false)
            setName('')
        }
        else {
            toast('This name already exists !')
        }

    }

    async function addFolderFunction() {
        const obj = {
            ID: new Date().getTime(),
            name: encrypt(name),
        }
        let snap = await userdb.child(String(key)).child('folder').orderByChild('name').equalTo(encrypt(name)).once('value')
        if (snap.val() == null) {
            await userdb.child(String(key)).child('folder').child(String(obj.ID)).set(obj)
            toast('Folder name has been updated')
            setAddFolder(false)
            setName('')
        }
        else {
            toast('This name already exists !')
        }

    }

    const uploadVideo = async () => {

        if (imguri != null && name != '' && selectedOption != null) {

            let snap = await userdb.child(String(key)).child('content').orderByChild('name').equalTo(encrypt(name)).once('value')

            if (snap.val() == null) {

                const obj = {
                    ID: new Date().getTime(),
                    uri: null,
                    name: encrypt(name),
                    type: 'video',
                    upload: encrypt(imguri.name),
                    duration: curr_duration,
                    folder: selectedOption
                }

                setLoading(true)
                toast('Please wait for confirmation message !');
                const uploadTask = storage.ref(`/images/${key}/${obj.ID}`).put(imguri);
                uploadTask.on('state_changed', snapshot => {
                    const progress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    // if (progress == 100) (setLoading(false));
                }, (error) => {
                    // Handle unsuccessful uploads
                    alert('error uploading image')
                }, () => {
                    storage.ref(`/images/${key}/${obj.ID}`).getDownloadURL().then((downloadURL) => {
                        obj.uri = downloadURL
                        userdb.child(String(key)).child('content').child(String(obj.ID)).set(obj).then(() => {
                            setLoading(false)
                            setimguri(null)
                            setName('')
                            setAddVideo(false)
                            setCurrDuration(0)
                            setPicture(null)
                            setSelectedOption(null)
                            toast('Video has been updated')
                        })
                    });
                })
                try {
                    await uploadTask;
                } catch (e) {
                    console.error(e);
                }
            }
            else toast('This name already exists !')
        }
        else toast('Please fill out all the required fields.')

    };

    const ref = useRef()
    const ref1 = useRef()

    const handleClick = (e) => {
        ref.current.click()
    }

    const [curr_duration, setCurrDuration] = useState(0)

    const onChangePicture = e => {
        const file = e.target.files?.[0];

        if (!file) return;

        const MAX_FILE_SIZE = 150 * 1024 * 1024; // 150 MB
        const MAX_VIDEO_DURATION = 120; // your previous logic

        const isImage = file.type.startsWith("image/");
        const isVideo = file.type.startsWith("video/");

        // allow only image or video
        if (!isImage && !isVideo) {
            setPicture(null);
            setimguri(null);
            toast("Please select an image or video file.");
            e.target.value = "";
            return;
        }

        // check size first
        if (file.size > MAX_FILE_SIZE) {
            setPicture(null);
            setimguri(null);
            toast("File size cannot be over 150 MB");
            e.target.value = "";
            return;
        }

        const reader = new FileReader();

        reader.addEventListener("load", () => {
            // Image file: no duration check needed
            if (isImage) {
                setPicture(reader.result);
                setimguri(file);
                setCurrDuration(null);
                return;
            }

            // Video file: check duration
            if (isVideo) {
                const media = document.createElement("video");
                media.preload = "metadata";

                media.onloadedmetadata = function () {
                    URL.revokeObjectURL(media.src);

                    if (media.duration < MAX_VIDEO_DURATION) {
                        setCurrDuration(media.duration);
                        setPicture(reader.result);
                        setimguri(file);
                    } else {
                        setPicture(null);
                        setimguri(null);
                        toast("The video length cannot exceed one minute.");
                        e.target.value = "";
                    }
                };

                media.onerror = function () {
                    URL.revokeObjectURL(media.src);
                    setPicture(null);
                    setimguri(null);
                    toast("Invalid video file.");
                    e.target.value = "";
                };

                media.src = URL.createObjectURL(file);
            }
        });

        reader.readAsDataURL(file);
    };

    const handleDropImage = (e) => {
        e.preventDefault()
        let temp = [];
        if (e != undefined && e.dataTransfer != undefined && e.dataTransfer.files.length > 0) {
            let files = Array.from(e.dataTransfer.files);
            let file = files[0]; //
            let temp = []
            const reader = new FileReader();
            if (file) {
                reader.addEventListener("load", () => {
                    var media = new Audio(reader.result);
                    media.onloadedmetadata = function () {
                        setCurrDuration(media.duration)
                    };
                    // uploadToFirebase(file);
                    setPicture(reader.result);
                    console.log('Details ', file)
                    setimguri(file)
                });
            }
            reader.readAsDataURL(file);
            console.log('All temp ', temp)
        }
        //console.log('All temp ', temp)
    }

    const [delete_content, setDeleteContent] = useState(false)

    function delet_content() {
        userdb.child(String(key)).child('content').child(String(delete_content)).remove()
        toast('Content is deleted !')
        setDeleteContent(false)
    }

    const [cursor_img, setCursorImg] = useState(null)
    const [cursor_vid, setCursorVid] = useState(null)


    const [selectedOption, setSelectedOption] = useState(null);

    const [opens, setOpens] = useState([])

    function removeOpens(ID) {
        let arr = [...opens]
        let temp = []
        for (let i = 0; i < arr.length; i++) {
            if (arr[i] != ID) {
                temp.push(arr[i])
            }
        }
        setOpens([...temp])
    }

    function getContentPerFolder(ID) {
        const search = search_content.trim().toLowerCase()

        return mycontent.filter((item) => {
            // Content must belong to this folder
            if (String(item.folder) !== String(ID)) {
                return false
            }

            // No search: keep the existing behaviour and show all folder content
            if (search === '') {
                return true
            }

            let uploadName = ''
            let contentName = ''

            try {
                uploadName = String(decrypt(item.upload || '')).toLowerCase()
            }
            catch (error) {
                uploadName = String(item.upload || '').toLowerCase()
            }

            try {
                contentName = String(decrypt(item.name || '')).toLowerCase()
            }
            catch (error) {
                contentName = String(item.name || '').toLowerCase()
            }

            return uploadName.includes(search) || contentName.includes(search)
        })
    }

    function showingWhenSearch(word) {
        if (search_content == '') return word
        else {
            let new_word = word.toLowerCase();
            let ser = search_content.toLowerCase()

            const index = new_word.indexOf(ser);
            if (index == -1) return word;
            else {
                let first = word.substring(0, index)
                let exact = word.substring(index, index + search_content.length)
                let last = word.substring(index + search_content.length, word.length)
                let arr = []
                arr.push(first)
                arr.push(<text style={{ color: '#F7941D' }}>{exact}</text>)
                arr.push(last)
                return arr;
            }

        }
    }


    const handleDragOver = (event) => {
        event.preventDefault()
    }

    useEffect(() => {
        const search = search_content.trim().toLowerCase()

        // No search: keep the existing page exactly as before
        if (search === '') {
            setShowFolders([...my_folders])
            return
        }

        const matchingFolderIds = new Set()

        for (let i = 0; i < mycontent.length; i++) {
            const item = mycontent[i]
            let uploadName = ''
            let contentName = ''

            try {
                uploadName = String(decrypt(item.upload || '')).toLowerCase()
            }
            catch (error) {
                uploadName = String(item.upload || '').toLowerCase()
            }

            try {
                contentName = String(decrypt(item.name || '')).toLowerCase()
            }
            catch (error) {
                contentName = String(item.name || '').toLowerCase()
            }

            if (uploadName.includes(search) || contentName.includes(search)) {
                matchingFolderIds.add(String(item.folder))
            }
        }

        const matchedFolders = my_folders.filter((folder) =>
            matchingFolderIds.has(String(folder.ID))
        )

        // During search show only folders that contain matching content
        setShowFolders(matchedFolders)

        // Automatically open only the folders that contain search results
        setOpens(matchedFolders.map((folder) => folder.ID))

    }, [search_content, mycontent, my_folders])

    const [type, setType] = useState(false)


    const [width, setwidth] = useState(window.innerWidth);
    const [height, setWindowHeight] = useState(window.innerHeight);

    useEffect(() => {
        const windowSizeHandler = () => {
            setwidth(window.innerWidth)
            setWindowHeight(window.innerHeight)
        };
        window.addEventListener("resize", windowSizeHandler);

        return () => {
            window.removeEventListener("resize", windowSizeHandler);
        };
    }, []);

    const isMobile = width <= 768;

    // ✅ you asked: wider drawer on mobile (0.80)
    const drawerW = isMobile ? width * 0.80 : width * 0.20;


    const [drawerOpen, setDrawerOpen] = useState(false);

    function handleOpenDrawerButton() {
        setDrawerOpen(!drawerOpen);
    }

    function handleBackdropClick() {
        setDrawerOpen(false);
    }


    let drawerClasses = drawerOpen ? "side-drawer open" : "side-drawer";

    console.log('items.devices ', items.devices)

    return (
        !isMobile ? <div style={{ backgroundColor: '#080A0C', display: 'flex', flexDirection: 'row', width: width, minHeight: '100vh', position: 'absolute', top: 0, left: 0 }}>



            <div style={{ backgroundColor: '#080A0C', position: 'fixed', top: 0, left: 0, display: 'flex', flexDirection: 'column', height: '100vh', width: width * 0.20, textAlign: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: "#080A0C", width: width * 0.20, height: 100, justifyContent: 'center', alignItems: 'center' }}>
                    <img
                        src={logo}
                        alt="Logo"
                        style={{ width: 113, marginTop: 1, height: 53, alignSelf: 'center' }}
                    />
                </div>

                {items.show_welcome ? <div onClick={() => navigate('/Welcome')} style={{ cursor: 'pointer', marginTop: 20, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>

                    <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Welcome</text>
                        <div style={{ height: 41, width: 20 }} />
                    </div>
                </div> : null}


                <div onClick={() => navigate('/Devices')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>

                    <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Devices</text>
                        <div style={{ height: 41, width: 20 }} />
                    </div>

                </div>

                <div style={{ marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>
                    <div style={{ backgroundColor: '#181E25', width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Content</text>
                        <img src={require('../assets/right.png')} style={{ height: 41, width: 20 }} />
                    </div>
                </div>

                <div onClick={() => navigate('/Calendars')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>

                    <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Calendar</text>
                        <div style={{ height: 41, width: 20 }} />
                    </div>
                </div>

                <div
                    onClick={() => setAiOpen(!aiOpen)}
                    style={{
                        cursor: "pointer",
                        marginTop: 5,
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                        width: 0.18 * width,
                        padding: 10,
                        alignSelf: "center",
                        alignItems: "center",
                        height: 52,
                    }}
                >
                    <div
                        style={{
                            width: 0.14 * width,
                            flexDirection: "row",
                            display: "flex",
                            padding: 10,
                            borderRadius: 6,
                            height: 52,
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        <text style={{ color: "white", marginLeft: 30, fontWeight: "600", fontSize: 16 }}>
                            AI Generator
                        </text>

                        <img
                            src={require("../assets/right.png")}
                            style={{
                                height: 41,
                                width: 20,
                                transform: aiOpen ? "rotate(90deg)" : "rotate(0deg)",
                                transition: "transform 200ms ease",
                            }}
                        />
                    </div>
                </div>

                <Collapse isOpened={aiOpen}>
                    <AiLeftSubMenuDesktop />
                </Collapse>

                <div onClick={() => navigate('/Subscription')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>
                    <div style={{ position: 'relative', width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Subscription</text>
                        <div style={{ height: 41, width: 20 }} />

                        {items.unlicensed > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: 'red', top: 5, left: 5 }}>
                            <text style={{ color: 'red', fontSize: 13 }}>{items.unlicensed}</text>
                        </div>}
                        {items.trial > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: '#F7941D', top: 5, right: 20 }}>
                            <text style={{ color: '#F7941D', fontSize: 13 }}>{items.trial}</text>
                        </div>}
                    </div>

                </div>


                <div onClick={() => navigate('/Settings')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>

                    <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Settings</text>
                        <div style={{ height: 41, width: 20 }} />
                    </div>
                </div>

            </div>


            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: width * 0.20, width: width * 0.80, position: 'absolute', top: 0, minHeight: '100vh', backgroundColor: '#181E25', alignItems: 'flex-end' }}>

                <div style={{ display: 'flex', height: 100, width: width * 0.7991, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C' }}>

                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: (0.74 * width) - 105 }}>
                        <text style={{ marginLeft: 0, fontSize: 24, fontWeight: '700', letterSpacing: 1.01, color: 'white', textAlign: 'center' }}>Content</text>
                        {
                        /*
                        <div style={{ marginLeft: 6, marginTop: 4 }}>
                            <stripe-buy-button
                                buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                                publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
                            >
                            </stripe-buy-button>
                        </div>
*/}
                    </div>




                    <div onClick={() => {

                        navigate('/');
                        localStorage.removeItem('display')
                        localStorage.removeItem('devices')
                        SetId(null)

                    }} style={{ cursor: 'pointer', alignSelf: 'center', width: 105, height: 36, borderRadius: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderWidth: 1, borderStyle: 'solid', borderColor: '#F7941D' }}>
                        <text style={{ color: '#F7941D', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Log out</text>
                    </div>
                </div>


                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#181E25', width: width * 0.80, minHeight: 'calc(100vh - 100px)', paddingBottom: 30, boxSizing: 'border-box' }}>


                    <div style={{ width: 0.74 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 20, backgroundColor: '#F7941D', borderRadius: 12 }}>
                        <div style={{ width: 0.73 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', }}>

                            <div style={{ width: 320, height: 46, flexDirection: 'row', justifyContent: 'space-between', display: 'flex' }}>
                                <div onClick={() => {
                                    if (items.devices > 0) setAddVideo(true)
                                    else setType(true)
                                }} style={{ cursor: 'pointer', display: 'flex', width: 150, height: 46, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
                                    {add_video}
                                    <text style={{ fontWeight: '600', fontSize: 18, color: 'black', marginLeft: 14 }}>Add Video</text>
                                </div>
                                <div onClick={() => {
                                    if (items.devices > 0) setAddImage(true)
                                    else setType(true)
                                }} style={{ cursor: 'pointer', display: 'flex', width: 150, height: 46, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
                                    {add_image}
                                    <text style={{ fontWeight: '600', fontSize: 18, color: 'black', marginLeft: 14 }}>Add Image</text>
                                </div>

                            </div>

                            <div style={{ position: 'relative', display: 'flex', flexDirection: 'row', alignItems: 'center', width: 285 }}>
                                <input placeholder='Search content here..' style={{ padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 280, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 17, fontFamily: "Open Sans", paddingLeft: 10, marginRight: 15 }} type="text" value={search_content} onChange={(e) => setSearchContent(e.target.value)} />

                                {search_content != '' && <IoMdCloseCircleOutline onClick={() => { setSearchContent(''); setOpens([]) }} color='black' size={20} style={{ cursor: 'pointer', position: 'absolute', right: 20 }} />}

                            </div>


                            <div style={{ width: 200, height: 46, flexDirection: 'row', justifyContent: 'flex-end', display: 'flex' }}>
                                <div onClick={() => {
                                    if (items.devices > 0) setAddFolder(true)
                                    else setType(true)
                                }} style={{ cursor: 'pointer', display: 'flex', width: 170, height: 46, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
                                    <FaFolderClosed style={{ fontSize: 22 }} />
                                    <text style={{ fontWeight: '600', fontSize: 18, color: 'black', marginLeft: 15 }}>Add Folder</text>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div style={{ width: 0.74 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 20, backgroundColor: '#080A0C', borderRadius: 12, borderWidth: 0, borderColor: '#ECFEFD', borderStyle: 'solid' }}>
                        <div style={{ width: 0.73 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', alignSelf: 'center', }}>
                            <text style={{ fontWeight: '700', fontSize: 22, color: '#F4F3EF', marginLeft: 15 }}>Folders</text>
                        </div>



                    </div>


                    {show_folders.map((item, index) =>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <div onClick={() => {
                                if (opens.includes(item.ID)) { removeOpens(item.ID) }
                                else { setOpens([...opens, item.ID]) }
                            }} style={{ cursor: 'pointer', width: 0.74 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 5, backgroundColor: '#080A0C', borderRadius: 12 }}>
                                <div style={{ width: 0.73 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', }}>

                                    <div style={{ width: 0.18 * width, height: 46, flexDirection: 'row', justifyContent: 'flex-start', display: 'flex' }}>
                                        <FaFolder style={{ cursor: 'pointer', color: '#F7941D', fontSize: 24, alignSelf: 'center', marginLeft: 15 }} />
                                        <text style={{ fontWeight: '600', fontSize: 17, color: '#ECFEFD', alignSelf: 'center', marginLeft: 20 }}>{item.name}</text>
                                        <RiEditFill onClick={(e) => { e.stopPropagation(); setName(item.name); setEditFolder(item) }} style={{ cursor: 'pointer', color: '#F7941D', fontSize: 24, alignSelf: 'center', marginLeft: 20 }} />
                                    </div>

                                    <div style={{ width: 0.12 * width, height: 46, flexDirection: 'row', justifyContent: 'flex-end', display: 'flex', marginRight: 15 }}>
                                        <TbTopologyStar2 style={{ cursor: 'pointer', color: '#F7941D', fontSize: 24, alignSelf: 'center', marginRight: 25 }} />
                                        {!opens.includes(item.ID) && <FiPlusCircle onClick={() => {
                                            if (opens.includes(item.ID)) { removeOpens(item.ID) }
                                            else { setOpens([...opens, item.ID]) }
                                        }} style={{ cursor: 'pointer', color: '#F7941D', fontSize: 24, alignSelf: 'center', marginLeft: 0 }} />}

                                        {opens.includes(item.ID) && <FiMinusCircle onClick={() => {
                                            if (opens.includes(item.ID)) { removeOpens(item.ID) }
                                            else { setOpens([...opens, item.ID]) }
                                        }} style={{ cursor: 'pointer', color: '#F7941D', fontSize: 24, alignSelf: 'center', marginLeft: 0 }} />}

                                    </div>

                                </div>
                            </div>

                            <Collapsible style={{ display: 'flex', flexDirection: 'column', maxHeight: 300, width: 0.80 * width, alignItems: 'center', justifyContent: 'center', alignSelf: 'center', alignContent: 'center' }} transitionTime={500} open={opens.includes(item.ID)}>

                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>

                                    <div style={{ width: 0.73 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', }}>
                                        <div style={{ display: 'flex', height: 56, width: '25%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                            <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>Upload</text>
                                        </div>
                                        <div style={{ display: 'flex', height: 56, width: '25%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                            <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>Name</text>
                                        </div>

                                        <div style={{ display: 'flex', height: 56, width: '20%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                            <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>Image or Video</text>
                                        </div>
                                        <div style={{ display: 'flex', height: 56, width: '13%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                            <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>View</text>
                                        </div>
                                        <div style={{ display: 'flex', height: 56, width: '13%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                            <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>Delete</text>
                                        </div>
                                    </div>

                                    <div style={{ alignSelf: 'center', justifyContent: 'space-between', width: 0.73 * width, display: 'flex', flexDirection: 'column', alignItems: 'center', alignSelf: 'center', marginTop: 5, overflowY: 'auto', maxHeight: 280, overflowX: 'hidden', marginLeft: 10 }}>
                                        {
                                            getContentPerFolder(item.ID).map((item, id) => <div style={{ width: 0.73 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 15 }}>
                                                <div style={{ display: 'flex', height: 56, width: '25%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                                    <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>{showingWhenSearch(decrypt(item.upload))}</text>
                                                </div>
                                                <div onClick={() => { setEditContentName(item); setName(decrypt(item.name)) }} style={{ cursor: 'pointer', display: 'flex', height: 56, width: '25%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                                    <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>{showingWhenSearch(decrypt(item.name))} ✍🏻</text>
                                                </div>

                                                <div style={{ display: 'flex', height: 56, width: '20%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                                    <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>{item.type}</text>
                                                </div>
                                                <div onMouseLeave={() => { setCursorImg(null); setCursorVid(null) }} onMouseEnter={() => { if (item.type == 'image') { setCursorImg(item.uri); setCursorVid(null) } else { setCursorVid(item.uri); setCursorImg(null) } }} style={{ cursor: 'pointer', display: 'flex', height: 56, width: '13%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                                    <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>{view_icon}</text>
                                                </div>
                                                <div onClick={() => setDeleteContent(item.ID)} style={{ cursor: 'pointer', display: 'flex', height: 56, width: '13%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                                    <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>{delete_icon}</text>
                                                </div>
                                            </div>)
                                        }
                                    </div>
                                </div>
                            </Collapsible>

                        </div>
                    )}


                </div>

            </div>

            <input id="actual" ref={ref} accept="image/*" onChange={onChangePicture} type="file" hidden={true} />
            <input id="actual" ref={ref1} accept="video/*" onChange={onChangePicture} type="file" hidden={true} />


            <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 600) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, justifyContent: 'center' } }}
                isOpen={addImage}
                onRequestClose={() => { setAddImage(false); setName(''); setPicture(null) }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div onDragOver={handleDragOver}
                    onDrop={handleDropImage} style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                    <IoIosCloseCircle onClick={() => { setAddImage(false); setName(''); setPicture(null) }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={34} />

                    <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                        <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 24 }}>Add Image</text></div>
                        {picture == null ? <RiImageAddLine onClick={() => ref.current?.click()} style={{ cursor: 'pointer', color: '#F7941D', fontSize: 80, alignSelf: 'center', marginTop: 10 }} /> : <img onClick={() => ref.current?.click()} src={picture} style={{ cursor: 'pointer', height: 100, width: 100, alignSelf: 'center' }} />}

                        <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: name == '' ? 'red' : 'white', marginTop: 20, opacity: 1 }}>Image Name</text>
                        <input placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 290, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />
                        <text style={{ fontFamily: 'Poppins', width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: selectedOption == null ? 'red' : 'white', marginTop: 10, opacity: 1 }}>Select Folder</text>
                        <div style={{ display: 'flex', flexDirection: 'column', width: 302, justifyContent: 'center', alignContent: 'center', height: 45, backgroundColor: 'transparent', marginTop: 10, marginLeft: -5 }}>
                            <Select
                                defaultValue={selectedOption}
                                onChange={(e) => setSelectedOption(e.ID)}
                                options={my_folders}
                                className="basic-single"
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        textAlign: "left",
                                        fontWeight: '500',
                                        minHeight: 36,
                                        height: 43,
                                        backgroundColor: '#ECFEFD',
                                        borderStyle: 'none',
                                        fontFamily: 'Poppins', color: 'black', fontWeight: '500', fontSize: 14,
                                        borderRadius: 6,
                                        boxShadow: 'none'
                                    })
                                }}
                                maxMenuHeight={200}
                                menuPlacement='top'
                                menuShouldScrollIntoView={true}
                            />
                        </div>

                        <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => uploadImage()} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Add</text> </div>
                    </div>
                </div>
            </ReactModal>

            <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 600) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, justifyContent: 'center' } }}
                isOpen={addVideo}
                onRequestClose={() => { setAddVideo(false); setName(''); setPicture(null) }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div onDragOver={handleDragOver}
                    onDrop={handleDropImage} style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                    <IoIosCloseCircle onClick={() => { setAddVideo(false); setName(''); setPicture(null) }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                    <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                        <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 24 }}>Add Video</text></div>
                        {picture == null ? <RiVideoAddFill onClick={() => ref1.current?.click()} style={{ cursor: 'pointer', color: '#F7941D', fontSize: 85, alignSelf: 'center', marginTop: 10 }} /> : <video onClick={() => ref1.current?.click()} onLoadedMetadata={(e) => console.log('media ', e)} src={picture} style={{ cursor: 'pointer', height: 100, width: 100, alignSelf: 'center' }} />}
                        {loading && <div style={{ padding: 10, alignSelf: 'center' }}><Levels size={30} color='white' /></div>}

                        <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: name == '' ? 'red' : '#ECFEFD', marginTop: 20, opacity: 1 }}>Video Name</text>
                        <input placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 290, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />
                        <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: selectedOption == null ? 'red' : 'white', marginTop: 10, opacity: 1 }}>Select Folder</text>
                        <div style={{ display: 'flex', flexDirection: 'column', width: 302, justifyContent: 'center', alignContent: 'center', height: 45, backgroundColor: 'transparent', marginTop: 10, marginLeft: -5 }}>
                            <Select
                                defaultValue={selectedOption}
                                onChange={(e) => setSelectedOption(e.ID)}
                                options={my_folders}
                                className="basic-single"
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        textAlign: "left",
                                        fontWeight: '500',
                                        minHeight: 36,
                                        height: 43,
                                        backgroundColor: '#ECFEFD',
                                        borderStyle: 'none',
                                        fontFamily: 'Poppins', color: 'black', fontWeight: '500', fontSize: 14,
                                        borderRadius: 6,
                                        boxShadow: 'none'
                                    })
                                }}
                                maxMenuHeight={200}
                                menuPlacement='top'
                                menuShouldScrollIntoView={true}
                            />
                        </div>

                        <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => uploadVideo()} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Add</text> </div>
                    </div>
                </div>
            </ReactModal>


            <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 600) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, justifyContent: 'center' } }}
                isOpen={addFolder}
                onRequestClose={() => { setAddFolder(false); setName(''); }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                    <IoIosCloseCircle onClick={() => { setAddFolder(false); setName(''); }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                    <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                        <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 24 }}>Add Folder</text></div>
                        <img onClick={() => { }} src={require('../assets/file_photo.png')} style={{ cursor: 'pointer', height: 100, width: 100, alignSelf: 'center' }} />   {loading && <div style={{ padding: 10, alignSelf: 'center' }}><Levels size={30} /></div>}

                        <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: name == '' ? 'red' : '#ECFEFD', marginTop: 20, opacity: 1 }}>Folder Name</text>
                        <input placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 290, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />

                        <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => addFolderFunction()} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Create</text> </div>
                    </div>
                </div>
            </ReactModal>

            <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 600) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, justifyContent: 'center' } }}
                isOpen={editFolder != false}
                onRequestClose={() => { setEditFolder(false); setName(''); }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                    <IoIosCloseCircle onClick={() => { setEditFolder(false); setName(''); }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                    <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                        <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 24 }}>Update Folder</text></div>
                        <img onClick={() => { }} src={require('../assets/file_photo.png')} style={{ cursor: 'pointer', height: 100, width: 100, alignSelf: 'center' }} />   {loading && <div style={{ padding: 10, alignSelf: 'center' }}><Levels size={30} /></div>}

                        <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: '#ECFEFD', marginTop: 20, opacity: 1 }}>Folder Name</text>
                        <input placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 290, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />

                        <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => EditFolderFunction()} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Update</text> </div>
                    </div>
                </div>
            </ReactModal>

            <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 600) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, justifyContent: 'center' } }}
                isOpen={edit_content_name != null}
                onRequestClose={() => { setEditContentName(null); setName(''); }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                    <IoIosCloseCircle onClick={() => { setEditContentName(null); setName(''); }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                    <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                        <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 24 }}>Update Content Name</text></div>

                        <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: '#ECFEFD', marginTop: 20, opacity: 1 }}>Content Name</text>
                        <input placeholder='Content Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 290, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />

                        <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => EditContentName()} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Update</text> </div>
                    </div>
                </div>
            </ReactModal>



            <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 550) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 300, justifyContent: 'center' } }}
                isOpen={delete_content}
                onRequestClose={() => { setDeleteContent(false) }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                    <IoIosCloseCircle onClick={() => setDeleteContent(false)} style={{ position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                    <div style={{ display: 'flex', flexDirection: 'column', width: '75%', justifyContent: 'center', alignContent: 'center', marginTop: 0 }}>
                        <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', cursor: 'pointer' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 20 }}>Are you sure to delete this content ?</text></div>

                        <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: 400, justifyContent: 'space-around', marginTop: 40, cursor: 'pointer' }}>
                            <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => delet_content()} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', width: 130, backgroundColor: '#3AB549', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center' }}> <text style={{ color: 'white', fontWeight: 'bold', fontSize: 17 }}>Yes</text> </div>
                            <div onClick={() => setDeleteContent(false)} style={{ height: 40, padding: 5, width: 130, backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 5 }}>
                                <text style={{ fontWeight: '600', fontSize: 15, color: 'white' }}>No</text>
                            </div>
                        </div>
                    </div>
                </div>
            </ReactModal>

            <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 570) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 200, justifyContent: 'center' } }}
                isOpen={type != false}
                onRequestClose={() => { setType(false) }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                    <IoIosCloseCircle onClick={() => setType(false)} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                    <div style={{
                        padding: `10px 15px`,
                        borderRadius: `20px`,
                        marginBottom: `10px`,
                        maxWidth: '70%',
                        display: 'inline-block'
                    }}>
                        <div style={{
                            display: 'flex',
                            backgroundColor: 'rgba(105, 124, 154, 255)',
                            color: 'white',
                            alignSelf: 'flex-end',
                            alignItems: 'center',
                            padding: 30, borderTopLeftRadius: 20, borderTopRightRadius: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 6
                        }}>
                            <text style={{ color: 'white', fontWeight: '600', fontSize: 18 }}>
                                <Typewriter words={['Please add device first']} />
                            </text>

                            <GoLinkExternal onClick={() => navigate('/Devices', { state: { add: true } })} size={20} color='#F7941D' style={{ cursor: 'pointer', marginTop: 2, marginLeft: 6 }} />

                        </div>
                    </div>

                </div>
            </ReactModal >



            <wc-toast></wc-toast>

            {cursor_img ? <img src={cursor_img} style={{ objectFit: 'contain', position: 'absolute', bottom: 10, left: 5, height: 250, width: (0.20 * width) - 10 }} /> : null}
            {cursor_vid ? <video autoPlay src={cursor_vid} style={{ objectFit: 'contain', position: 'absolute', bottom: 10, left: 5, height: 250, width: (0.20 * width) - 10 }} /> : null}

        </div > : <div style={{ backgroundColor: '#080A0C', display: 'flex', flexDirection: 'row', width: width, minHeight: '100vh', position: 'absolute', top: 0, left: 0 }}>

            <div className={drawerClasses} style={{ width: drawerW }}>
                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: "#080A0C", width: drawerW, height: 60, justifyContent: 'center', alignItems: 'center' }}>
                    <img
                        src={logo}
                        alt="Logo"
                        style={{ width: 113, marginTop: 1, height: 53, alignSelf: 'center' }}
                    />
                </div>


                {/* CONTENT */}
                {items.show_welcome ? <div onClick={() => navigate('/Welcome')} style={{ cursor: 'pointer', marginTop: 10, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Welcome</text>
                        <div style={{ height: 30, width: 20 }} />
                    </div>
                </div> : null}

                {/* DEVICES */}
                <div onClick={() => navigate('/Devices')} style={{ cursor: 'pointer', marginTop: items.show_welcome ? 5 : 20, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Devices</text>
                        <div style={{ height: 30, width: 20 }} />
                    </div>
                </div>

                {/* CONTENT */}
                <div style={{ marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW - 30, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30 }}>
                    <div style={{ backgroundColor: '#181E25', width: drawerW - 42, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 30, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 32) - 46)}>Content</text>
                        <img src={require('../assets/right.png')} style={{ height: 30, width: 20 }} />
                    </div>
                </div>

                {/* CALENDAR */}
                <div onClick={() => navigate('/Calendars')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Calendar</text>
                        <div style={{ height: 30, width: 20 }} />
                    </div>
                </div>


                <div onClick={() => navigate('/AIGenerator')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>AI Generator</text>
                        <div style={{ height: 30, width: 20 }} />
                    </div>
                </div>

                {/* SUBSCRIPTION */}
                <div onClick={() => navigate('/Subscription')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ position: 'relative', width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Subscription</text>
                        <div style={{ height: 30, width: 20 }} />
                        {items.unlicensed > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: 'red', top: 5, left: 5 }}>
                            <text style={{ color: 'red', fontSize: 13 }}>{items.unlicensed}</text>
                        </div>}
                        {items.trial > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: '#F7941D', top: 5, right: 20 }}>
                            <text style={{ color: '#F7941D', fontSize: 13 }}>{items.trial}</text>
                        </div>}
                    </div>
                </div>

                {/* SETTINGS */}
                <div onClick={() => navigate('/Settings')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 30, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Settings</text>
                        <div style={{ height: 30, width: 20 }} />
                    </div>
                </div>

                <div onClick={() => {
                    navigate('/')
                    localStorage.removeItem('display')
                    localStorage.removeItem('devices')
                    SetId(null)
                }} style={{ left: ((0.35 * width) - 100) / 2, position: 'absolute', bottom: 10, alignContent: 'center', cursor: 'pointer', alignSelf: 'center', width: 150, height: 36, borderRadius: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderWidth: 1, borderStyle: 'solid', borderColor: '#F7941D' }}>
                    <text style={{ color: '#F7941D', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Log out</text>
                </div>

            </div>


            {drawerOpen && <BackDrop closeDrawer={handleBackdropClick} />}


            <div style={{ display: 'flex', flexDirection: 'column', width: width, position: 'absolute', top: 0, minHeight: '100vh', backgroundColor: '#181E25', alignItems: 'flex-end' }}>

                <div style={{ display: 'flex', height: 100, width: width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C' }}>

                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: (width * 0.94) - 5 }}>

                        <div style={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <VscThreeBars size={30} color='white' onClick={handleOpenDrawerButton} />
                        </div>

                        <div style={{ marginLeft: 6, marginTop: 4 }}>
                            <stripe-buy-button
                                buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                                publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
                            >
                            </stripe-buy-button>
                        </div>
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#181E25', width: width, minHeight: 'calc(100vh - 100px)', paddingBottom: 30, boxSizing: 'border-box' }}>


                    <div style={{ width: 0.94 * width, height: 120, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 20, backgroundColor: '#F7941D' }}>
                        <div style={{ width: 0.93 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', alignSelf: 'center', }}>

                            <div onClick={() => {
                                if (items.devices > 0) setAddVideo(true)
                                else setType(true)
                            }} style={{ cursor: 'pointer', display: 'flex', width: 118, height: 46, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row', marginLeft: 10 }}>
                                {add_video}
                                <text style={{ fontWeight: '600', fontSize: 14, color: 'black', marginLeft: 10 }}>Add Video</text>
                            </div>

                            <div onClick={() => {
                                if (items.devices > 0) setAddImage(true)
                                else setType(true)
                            }} style={{ cursor: 'pointer', display: 'flex', width: 118, height: 46, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row', marginLeft: 10 }}>
                                {add_image}
                                <text style={{ fontWeight: '600', fontSize: 14, color: 'black', marginLeft: 10 }}>Add Image</text>
                            </div>


                            <div style={{ width: 130, height: 46, flexDirection: 'row', justifyContent: 'flex-end', display: 'flex' }}>
                                <div onClick={() => {
                                    if (items.devices > 0) setAddFolder(true)
                                    else setType(true)
                                }} style={{ cursor: 'pointer', display: 'flex', width: 120, height: 46, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row', marginLeft: 10 }}>
                                    <FaFolderClosed style={{ fontSize: 18 }} />
                                    <text style={{ fontWeight: '600', fontSize: 14, color: 'black', marginLeft: 10 }}>Add Folder</text>
                                </div>

                            </div>
                        </div>
                        <div style={{ position: 'relative', display: 'flex', flexDirection: 'row', alignItems: 'center', width: 0.93 * width, alignSelf: 'center', marginLeft: 15, marginBottom: 4 }}>
                            <input placeholder='Search content here..' style={{ padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: '98%', backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 17, fontFamily: "Open Sans", paddingLeft: 10, marginRight: 15 }} type="text" value={search_content} onChange={(e) => setSearchContent(e.target.value)} />

                            {search_content != '' && <IoMdCloseCircleOutline onClick={() => { setSearchContent(''); setOpens([]) }} color='black' size={20} style={{ cursor: 'pointer', position: 'absolute', right: 20 }} />}

                        </div>
                    </div>

                    <div style={{ width: 0.94 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 20, backgroundColor: '#080A0C', borderRadius: 12, borderWidth: 0, borderColor: '#ECFEFD', borderStyle: 'solid' }}>
                        <div style={{ width: 0.93 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', alignSelf: 'center', }}>
                            <text style={{ fontWeight: '700', fontSize: 22, color: '#F4F3EF', marginLeft: 15 }}>Folders</text>
                        </div>

                    </div>


                    {show_folders.map((item, index) =>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <div onClick={() => {
                                if (opens.includes(item.ID)) { removeOpens(item.ID) }
                                else { setOpens([...opens, item.ID]) }
                            }} style={{ cursor: 'pointer', width: 0.94 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 5, backgroundColor: '#080A0C', borderRadius: 12 }}>
                                <div style={{ width: 0.93 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', }}>

                                    <div style={{ width: 0.88 * width, height: 46, flexDirection: 'row', justifyContent: 'flex-start', display: 'flex' }}>
                                        <FaFolder style={{ cursor: 'pointer', color: '#F7941D', fontSize: 24, alignSelf: 'center', marginLeft: 15 }} />
                                        <text style={{ fontWeight: '600', fontSize: 16, color: '#ECFEFD', alignSelf: 'center', marginLeft: 20 }}>{item.name}</text>
                                        <RiEditFill onClick={(e) => { e.stopPropagation(); setName(item.name); setEditFolder(item) }} style={{ cursor: 'pointer', color: '#F7941D', fontSize: 24, alignSelf: 'center', marginLeft: 20 }} />

                                    </div>

                                    <div style={{ width: 0.82 * width, height: 46, flexDirection: 'row', justifyContent: 'flex-end', display: 'flex', marginRight: 15 }}>
                                        <TbTopologyStar2 style={{ cursor: 'pointer', color: '#F7941D', fontSize: 24, alignSelf: 'center', marginRight: 25 }} />
                                        {!opens.includes(item.ID) && <FiPlusCircle onClick={() => {
                                            if (opens.includes(item.ID)) { removeOpens(item.ID) }
                                            else { setOpens([...opens, item.ID]) }
                                        }} style={{ cursor: 'pointer', color: '#F7941D', fontSize: 24, alignSelf: 'center', marginLeft: 0 }} />}

                                        {opens.includes(item.ID) && <FiMinusCircle onClick={() => {
                                            if (opens.includes(item.ID)) { removeOpens(item.ID) }
                                            else { setOpens([...opens, item.ID]) }
                                        }} style={{ cursor: 'pointer', color: '#F7941D', fontSize: 24, alignSelf: 'center', marginLeft: 0 }} />}

                                    </div>

                                </div>
                            </div>

                            <Collapsible style={{ display: 'flex', flexDirection: 'column', maxHeight: 300, width: width, alignItems: 'center', justifyContent: 'center', alignSelf: 'center', alignContent: 'center', marginBottom: 2 }} transitionTime={500} open={opens.includes(item.ID)}>

                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>

                                    <div style={{ width: 0.93 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', }}>
                                        <div style={{ display: 'flex', height: 56, width: '25%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                            <text style={{ color: 'white', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Upload</text>
                                        </div>
                                        <div style={{ display: 'flex', height: 56, width: '25%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                            <text style={{ color: 'white', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Name</text>
                                        </div>

                                        <div style={{ display: 'flex', height: 56, width: '20%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                            <text style={{ color: 'white', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Image or Video</text>
                                        </div>
                                        <div style={{ display: 'flex', height: 56, width: '13%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                            <text style={{ color: 'white', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>View</text>
                                        </div>
                                        <div style={{ display: 'flex', height: 56, width: '13%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                            <text style={{ color: 'white', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Delete</text>
                                        </div>
                                    </div>

                                    <div style={{ alignSelf: 'center', justifyContent: 'space-between', width: 0.93 * width, display: 'flex', flexDirection: 'column', alignItems: 'center', alignSelf: 'center', marginTop: 5, overflowY: 'auto', maxHeight: 280, overflowX: 'hidden', marginLeft: 3 }}>
                                        {
                                            getContentPerFolder(item.ID).map((item, id) => <div style={{ width: 0.93 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 15 }}>
                                                <div style={{ display: 'flex', height: 'auto', minHeight: 56, width: '25%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                                    <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{showingWhenSearch(decrypt(item.upload))}</text>
                                                </div>
                                                <div onClick={() => { setEditContentName(item); setName(decrypt(item.name)) }} style={{ minHeight: 56, cursor: 'pointer', display: 'flex', height: 'auto', width: '25%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                                    <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{showingWhenSearch(decrypt(item.name))} ✍🏻</text>
                                                </div>

                                                <div style={{ display: 'flex', height: 'auto', minHeight: 56, width: '20%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                                    <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{item.type}</text>
                                                </div>
                                                <div onMouseLeave={() => { setCursorImg(null); setCursorVid(null) }} onMouseEnter={() => { if (item.type == 'image') { setCursorImg(item.uri); setCursorVid(null) } else { setCursorVid(item.uri); setCursorImg(null) } }} style={{ minHeight: 56, cursor: 'pointer', display: 'flex', height: 'auto', width: '13%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                                    <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{view_icon}</text>
                                                </div>
                                                <div onClick={() => setDeleteContent(item.ID)} style={{ minHeight: 56, cursor: 'pointer', display: 'flex', height: 'auto', width: '13%', justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                                    <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{delete_icon}</text>
                                                </div>
                                            </div>)
                                        }
                                    </div>
                                </div>
                            </Collapsible>

                        </div>
                    )}


                </div>



                <input id="actual" ref={ref} accept="image/*" onChange={onChangePicture} type="file" hidden={true} />
                <input id="actual" ref={ref1} accept="video/*" onChange={onChangePicture} type="file" hidden={true} />


                {!isMobile && <ReactModal
                    style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 600) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, justifyContent: 'center' } }}
                    isOpen={addImage}
                    onRequestClose={() => { setAddImage(false); setName(''); setPicture(null) }}
                    closeTimeoutMS={100}
                    shouldFocusAfterRender={true}
                    shouldCloseOnOverlayClick={true}
                    shouldCloseOnEsc={true}
                    shouldReturnFocusAfterClose={true}
                    preventScroll={true}
                >
                    <div onDragOver={handleDragOver}
                        onDrop={handleDropImage} style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                        <IoIosCloseCircle onClick={() => { setAddImage(false); setName(''); setPicture(null) }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={34} />

                        <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 24 }}>Add Image</text></div>
                            {picture == null ? <RiImageAddLine onClick={() => ref.current?.click()} style={{ cursor: 'pointer', color: '#F7941D', fontSize: 80, alignSelf: 'center', marginTop: 10 }} /> : <img onClick={() => ref.current?.click()} src={picture} style={{ cursor: 'pointer', height: 100, width: 100, alignSelf: 'center' }} />}

                            <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: name == '' ? 'red' : 'white', marginTop: 20, opacity: 1 }}>Image Name</text>
                            <input placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 290, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />
                            <text style={{ fontFamily: 'Poppins', width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: selectedOption == null ? 'red' : 'white', marginTop: 10, opacity: 1 }}>Select Folder</text>
                            <div style={{ display: 'flex', flexDirection: 'column', width: 302, justifyContent: 'center', alignContent: 'center', height: 45, backgroundColor: 'transparent', marginTop: 10, marginLeft: -5 }}>
                                <Select
                                    defaultValue={selectedOption}
                                    onChange={(e) => setSelectedOption(e.ID)}
                                    options={my_folders}
                                    className="basic-single"
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            textAlign: "left",
                                            fontWeight: '500',
                                            minHeight: 36,
                                            height: 43,
                                            backgroundColor: '#ECFEFD',
                                            borderStyle: 'none',
                                            fontFamily: 'Poppins', color: 'black', fontWeight: '500', fontSize: 14,
                                            borderRadius: 6,
                                            boxShadow: 'none'
                                        })
                                    }}
                                    maxMenuHeight={200}
                                    menuPlacement='top'
                                    menuShouldScrollIntoView={true}
                                />
                            </div>

                            <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => uploadImage()} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Add</text> </div>
                        </div>
                    </div>
                </ReactModal>}



                {isMobile && addImage &&
                    <div style={{ boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', width: 330, justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 20, position: 'absolute', top: 150, left: (width - 330) / 2, backgroundColor: '#111417', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, borderWidth: 2, borderColor: 'white', borderStyle: 'solid' }}>
                        <div onDragOver={handleDragOver}
                            onDrop={handleDropImage} style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                            <IoIosCloseCircle onClick={() => { setAddImage(false); setName(''); setPicture(null) }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={34} />

                            <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                                <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 24 }}>Add Image</text></div>
                                {picture == null ? <RiImageAddLine onClick={() => ref.current?.click()} style={{ cursor: 'pointer', color: '#F7941D', fontSize: 80, alignSelf: 'center', marginTop: 10 }} /> : <img onClick={() => ref.current?.click()} src={picture} style={{ cursor: 'pointer', height: 100, width: 100, alignSelf: 'center' }} />}

                                <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: name == '' ? 'red' : 'white', marginTop: 20, opacity: 1 }}>Image Name</text>
                                <input placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 290, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />
                                <text style={{ fontFamily: 'Poppins', width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: selectedOption == null ? 'red' : 'white', marginTop: 10, opacity: 1 }}>Select Folder</text>
                                <div style={{ display: 'flex', flexDirection: 'column', width: 302, justifyContent: 'center', alignContent: 'center', height: 45, backgroundColor: 'transparent', marginTop: 10, marginLeft: -5 }}>
                                    <Select
                                        defaultValue={selectedOption}
                                        onChange={(e) => setSelectedOption(e.ID)}
                                        options={my_folders}
                                        className="basic-single"
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: "left",
                                                fontWeight: '500',
                                                minHeight: 36,
                                                height: 43,
                                                backgroundColor: '#ECFEFD',
                                                borderStyle: 'none',
                                                fontFamily: 'Poppins', color: 'black', fontWeight: '500', fontSize: 14,
                                                borderRadius: 6,
                                                boxShadow: 'none'
                                            })
                                        }}
                                        maxMenuHeight={200}
                                        menuPlacement='top'
                                        menuShouldScrollIntoView={true}
                                    />
                                </div>

                                <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => uploadImage()} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Add</text> </div>
                            </div>
                        </div>

                    </div>
                }




                {!isMobile && <ReactModal
                    style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 600) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, justifyContent: 'center' } }}
                    isOpen={addVideo}
                    onRequestClose={() => { setAddVideo(false); setName(''); setPicture(null) }}
                    closeTimeoutMS={100}
                    shouldFocusAfterRender={true}
                    shouldCloseOnOverlayClick={true}
                    shouldCloseOnEsc={true}
                    shouldReturnFocusAfterClose={true}
                    preventScroll={true}
                >
                    <div onDragOver={handleDragOver}
                        onDrop={handleDropImage} style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                        <IoIosCloseCircle onClick={() => { setAddVideo(false); setName(''); setPicture(null) }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                        <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 24 }}>Add Video</text></div>
                            {picture == null ? <RiVideoAddFill onClick={() => ref1.current?.click()} style={{ cursor: 'pointer', color: '#F7941D', fontSize: 85, alignSelf: 'center', marginTop: 10 }} /> : <video onClick={() => ref1.current?.click()} onLoadedMetadata={(e) => console.log('media ', e)} src={picture} style={{ cursor: 'pointer', height: 100, width: 100, alignSelf: 'center' }} />}
                            {loading && <div style={{ padding: 10, alignSelf: 'center' }}><Levels size={30} color='white' /></div>}

                            <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: name == '' ? 'red' : '#ECFEFD', marginTop: 20, opacity: 1 }}>Video Name</text>
                            <input placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 290, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />
                            <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: selectedOption == null ? 'red' : 'white', marginTop: 10, opacity: 1 }}>Select Folder</text>
                            <div style={{ display: 'flex', flexDirection: 'column', width: 302, justifyContent: 'center', alignContent: 'center', height: 45, backgroundColor: 'transparent', marginTop: 10, marginLeft: -5 }}>
                                <Select
                                    defaultValue={selectedOption}
                                    onChange={(e) => setSelectedOption(e.ID)}
                                    options={my_folders}
                                    className="basic-single"
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            textAlign: "left",
                                            fontWeight: '500',
                                            minHeight: 36,
                                            height: 43,
                                            backgroundColor: '#ECFEFD',
                                            borderStyle: 'none',
                                            fontFamily: 'Poppins', color: 'black', fontWeight: '500', fontSize: 14,
                                            borderRadius: 6,
                                            boxShadow: 'none'
                                        })
                                    }}
                                    maxMenuHeight={200}
                                    menuPlacement='top'
                                    menuShouldScrollIntoView={true}
                                />
                            </div>

                            <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => uploadVideo()} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Add</text> </div>
                        </div>
                    </div>
                </ReactModal>}


                {isMobile && addVideo &&
                    <div style={{ boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', width: 330, justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 20, position: 'absolute', top: 150, left: (width - 330) / 2, backgroundColor: '#111417', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, borderWidth: 2, borderColor: 'white', borderStyle: 'solid' }}>
                        <div onDragOver={handleDragOver}
                            onDrop={handleDropImage} style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                            <IoIosCloseCircle onClick={() => { setAddVideo(false); setName(''); setPicture(null) }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                            <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                                <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 24 }}>Add Video</text></div>
                                {picture == null ? <RiVideoAddFill onClick={() => ref1.current?.click()} style={{ cursor: 'pointer', color: '#F7941D', fontSize: 85, alignSelf: 'center', marginTop: 10 }} /> : <video onClick={() => ref1.current?.click()} onLoadedMetadata={(e) => console.log('media ', e)} src={picture} style={{ cursor: 'pointer', height: 100, width: 100, alignSelf: 'center' }} />}
                                {loading && <div style={{ padding: 10, alignSelf: 'center' }}><Levels size={30} color='white' /></div>}

                                <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: name == '' ? 'red' : '#ECFEFD', marginTop: 20, opacity: 1 }}>Video Name</text>
                                <input placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 290, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />
                                <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: selectedOption == null ? 'red' : 'white', marginTop: 10, opacity: 1 }}>Select Folder</text>
                                <div style={{ display: 'flex', flexDirection: 'column', width: 302, justifyContent: 'center', alignContent: 'center', height: 45, backgroundColor: 'transparent', marginTop: 10, marginLeft: -5 }}>
                                    <Select
                                        defaultValue={selectedOption}
                                        onChange={(e) => setSelectedOption(e.ID)}
                                        options={my_folders}
                                        className="basic-single"
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: "left",
                                                fontWeight: '500',
                                                minHeight: 36,
                                                height: 43,
                                                backgroundColor: '#ECFEFD',
                                                borderStyle: 'none',
                                                fontFamily: 'Poppins', color: 'black', fontWeight: '500', fontSize: 14,
                                                borderRadius: 6,
                                                boxShadow: 'none'
                                            })
                                        }}
                                        maxMenuHeight={200}
                                        menuPlacement='top'
                                        menuShouldScrollIntoView={true}
                                    />
                                </div>

                                <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => uploadVideo()} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Add</text> </div>
                            </div>
                        </div>
                    </div>
                }


                {!isMobile && <ReactModal
                    style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 600) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, justifyContent: 'center' } }}
                    isOpen={addFolder}
                    onRequestClose={() => { setAddFolder(false); setName(''); }}
                    closeTimeoutMS={100}
                    shouldFocusAfterRender={true}
                    shouldCloseOnOverlayClick={true}
                    shouldCloseOnEsc={true}
                    shouldReturnFocusAfterClose={true}
                    preventScroll={true}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                        <IoIosCloseCircle onClick={() => { setAddFolder(false); setName(''); }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                        <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 24 }}>Add Folder</text></div>
                            <img onClick={() => { }} src={require('../assets/file_photo.png')} style={{ cursor: 'pointer', height: 100, width: 100, alignSelf: 'center' }} />   {loading && <div style={{ padding: 10, alignSelf: 'center' }}><Levels size={30} /></div>}

                            <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: name == '' ? 'red' : '#ECFEFD', marginTop: 20, opacity: 1 }}>Folder Name</text>
                            <input placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 290, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />

                            <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => addFolderFunction()} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Create</text> </div>
                        </div>
                    </div>
                </ReactModal>}


                {isMobile && addFolder &&
                    <div style={{ boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', width: 330, justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 20, position: 'absolute', top: 150, left: (width - 330) / 2, backgroundColor: '#111417', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, borderWidth: 2, borderColor: 'white', borderStyle: 'solid' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                            <IoIosCloseCircle onClick={() => { setAddFolder(false); setName(''); }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                            <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                                <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 24 }}>Add Folder</text></div>
                                <img onClick={() => { }} src={require('../assets/file_photo.png')} style={{ cursor: 'pointer', height: 100, width: 100, alignSelf: 'center' }} />   {loading && <div style={{ padding: 10, alignSelf: 'center' }}><Levels size={30} /></div>}

                                <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: name == '' ? 'red' : '#ECFEFD', marginTop: 20, opacity: 1 }}>Folder Name</text>
                                <input placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 290, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />

                                <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => addFolderFunction()} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Create</text> </div>
                            </div>
                        </div>
                    </div>}


                {!isMobile && <ReactModal
                    style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 600) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, justifyContent: 'center' } }}
                    isOpen={editFolder != false}
                    onRequestClose={() => { setEditFolder(false); setName(''); }}
                    closeTimeoutMS={100}
                    shouldFocusAfterRender={true}
                    shouldCloseOnOverlayClick={true}
                    shouldCloseOnEsc={true}
                    shouldReturnFocusAfterClose={true}
                    preventScroll={true}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                        <IoIosCloseCircle onClick={() => { setEditFolder(false); setName(''); }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                        <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 24 }}>Update Folder</text></div>
                            <img onClick={() => { }} src={require('../assets/file_photo.png')} style={{ cursor: 'pointer', height: 100, width: 100, alignSelf: 'center' }} />   {loading && <div style={{ padding: 10, alignSelf: 'center' }}><Levels size={30} /></div>}

                            <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: '#ECFEFD', marginTop: 20, opacity: 1 }}>Folder Name</text>
                            <input placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 290, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />

                            <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => EditFolderFunction()} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Update</text> </div>
                        </div>
                    </div>
                </ReactModal>}


                {isMobile && editFolder != false &&
                    <div style={{ boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', width: 330, justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 20, position: 'absolute', top: 150, left: (width - 330) / 2, backgroundColor: '#111417', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, borderWidth: 2, borderColor: 'white', borderStyle: 'solid' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                            <IoIosCloseCircle onClick={() => { setEditFolder(false); setName(''); }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                            <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                                <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 24 }}>Update Folder</text></div>
                                <img onClick={() => { }} src={require('../assets/file_photo.png')} style={{ cursor: 'pointer', height: 100, width: 100, alignSelf: 'center' }} />   {loading && <div style={{ padding: 10, alignSelf: 'center' }}><Levels size={30} /></div>}

                                <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: '#ECFEFD', marginTop: 20, opacity: 1 }}>Folder Name</text>
                                <input placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 290, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />

                                <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => EditFolderFunction()} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Update</text> </div>
                            </div>
                        </div>
                    </div>}




                {!isMobile && <ReactModal
                    style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 600) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, justifyContent: 'center' } }}
                    isOpen={edit_content_name != null}
                    onRequestClose={() => { setEditContentName(null); setName(''); }}
                    closeTimeoutMS={100}
                    shouldFocusAfterRender={true}
                    shouldCloseOnOverlayClick={true}
                    shouldCloseOnEsc={true}
                    shouldReturnFocusAfterClose={true}
                    preventScroll={true}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                        <IoIosCloseCircle onClick={() => { setEditContentName(null); setName(''); }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                        <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 24 }}>Update Content Name</text></div>

                            <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: '#ECFEFD', marginTop: 20, opacity: 1 }}>Content Name</text>
                            <input placeholder='Content Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 290, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />

                            <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => EditContentName()} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Update</text> </div>
                        </div>
                    </div>
                </ReactModal>}


                {isMobile && edit_content_name != null && <div style={{ boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', width: 330, justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 20, position: 'absolute', top: 150, left: (width - 330) / 2, backgroundColor: '#111417', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, borderWidth: 2, borderColor: 'white', borderStyle: 'solid' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                        <IoIosCloseCircle onClick={() => { setEditContentName(null); setName(''); }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                        <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 24 }}>Update Content Name</text></div>

                            <text style={{ width: 300, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: '#ECFEFD', marginTop: 20, opacity: 1 }}>Content Name</text>
                            <input placeholder='Content Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 290, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />

                            <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => EditContentName()} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Update</text> </div>
                        </div>
                    </div>
                </div>}



                {!isMobile && <ReactModal
                    style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 550) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 300, justifyContent: 'center' } }}
                    isOpen={delete_content}
                    onRequestClose={() => { setDeleteContent(false) }}
                    closeTimeoutMS={100}
                    shouldFocusAfterRender={true}
                    shouldCloseOnOverlayClick={true}
                    shouldCloseOnEsc={true}
                    shouldReturnFocusAfterClose={true}
                    preventScroll={true}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                        <IoIosCloseCircle onClick={() => setDeleteContent(false)} style={{ position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                        <div style={{ display: 'flex', flexDirection: 'column', width: '75%', justifyContent: 'center', alignContent: 'center', marginTop: 0 }}>
                            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', cursor: 'pointer' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 20 }}>Are you sure to delete this content ?</text></div>

                            <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: 400, justifyContent: 'space-around', marginTop: 40, cursor: 'pointer' }}>
                                <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => delet_content()} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', width: 130, backgroundColor: '#3AB549', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center' }}> <text style={{ color: 'white', fontWeight: 'bold', fontSize: 17 }}>Yes</text> </div>
                                <div onClick={() => setDeleteContent(false)} style={{ height: 40, padding: 5, width: 130, backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 5 }}>
                                    <text style={{ fontWeight: '600', fontSize: 15, color: 'white' }}>No</text>
                                </div>
                            </div>
                        </div>
                    </div>
                </ReactModal>}


                {isMobile && delete_content && <div style={{ boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', width: 330, justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 20, position: 'absolute', top: 150, left: (width - 330) / 2, backgroundColor: '#111417', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 300, borderWidth: 2, borderColor: 'white', borderStyle: 'solid' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                        <IoIosCloseCircle onClick={() => setDeleteContent(false)} style={{ position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                        <div style={{ display: 'flex', flexDirection: 'column', width: '75%', justifyContent: 'center', alignContent: 'center', marginTop: 0 }}>
                            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', cursor: 'pointer' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 20 }}>Are you sure to delete this content ?</text></div>

                            <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: 300, justifyContent: 'space-around', marginTop: 40, cursor: 'pointer' }}>
                                <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => delet_content()} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', width: 130, backgroundColor: '#3AB549', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center' }}> <text style={{ color: 'white', fontWeight: 'bold', fontSize: 17 }}>Yes</text> </div>
                                <div onClick={() => setDeleteContent(false)} style={{ height: 40, padding: 5, width: 130, backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 5 }}>
                                    <text style={{ fontWeight: '600', fontSize: 15, color: 'white' }}>No</text>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}



                {!isMobile && <ReactModal
                    style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 570) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 200, justifyContent: 'center' } }}
                    isOpen={type != false}
                    onRequestClose={() => { setType(false) }}
                    closeTimeoutMS={100}
                    shouldFocusAfterRender={true}
                    shouldCloseOnOverlayClick={true}
                    shouldCloseOnEsc={true}
                    shouldReturnFocusAfterClose={true}
                    preventScroll={true}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                        <IoIosCloseCircle onClick={() => setType(false)} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                        <div style={{
                            padding: `10px 15px`,
                            borderRadius: `20px`,
                            marginBottom: `10px`,
                            maxWidth: '70%',
                            display: 'inline-block'
                        }}>
                            <div style={{
                                display: 'flex',
                                backgroundColor: 'rgba(105, 124, 154, 255)',
                                color: 'white',
                                alignSelf: 'flex-end',
                                alignItems: 'center',
                                padding: 30, borderTopLeftRadius: 20, borderTopRightRadius: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 6
                            }}>
                                <text style={{ color: 'white', fontWeight: '600', fontSize: 18 }}>
                                    <Typewriter words={['Please add device first']} />
                                </text>

                                <GoLinkExternal onClick={() => navigate('/Devices', { state: { add: true } })} size={20} color='#F7941D' style={{ cursor: 'pointer', marginTop: 2, marginLeft: 6 }} />

                            </div>
                        </div>

                    </div>
                </ReactModal >}

                {isMobile && type != false && <div style={{ boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', width: 330, justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 20, position: 'absolute', top: 150, left: (width - 330) / 2, backgroundColor: '#111417', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 300, borderWidth: 2, borderColor: 'white', borderStyle: 'solid' }}>

                    <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                        <IoIosCloseCircle onClick={() => setType(false)} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                        <div style={{
                            padding: `10px 15px`,
                            borderRadius: `20px`,
                            marginBottom: `10px`,
                            maxWidth: '70%',
                            display: 'inline-block'
                        }}>
                            <div style={{
                                display: 'flex',
                                backgroundColor: 'rgba(105, 124, 154, 255)',
                                color: 'white',
                                alignSelf: 'flex-end',
                                alignItems: 'center',
                                padding: 30, borderTopLeftRadius: 20, borderTopRightRadius: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 6
                            }}>
                                <text style={{ color: 'white', fontWeight: '600', fontSize: 18 }}>
                                    <Typewriter words={['Please add device first']} />
                                </text>

                                <GoLinkExternal onClick={() => navigate('/Devices', { state: { add: true } })} size={20} color='#F7941D' style={{ cursor: 'pointer', marginTop: 2, marginLeft: 6 }} />

                            </div>
                        </div>

                    </div>

                </div>}


                <wc-toast></wc-toast>

                {cursor_img ? <img src={cursor_img} style={{ objectFit: 'contain', position: 'absolute', bottom: 10, left: 5, height: 250, width: (0.20 * width) - 10 }} /> : null}
                {cursor_vid ? <video autoPlay src={cursor_vid} style={{ objectFit: 'contain', position: 'absolute', bottom: 10, left: 5, height: 250, width: (0.20 * width) - 10 }} /> : null}

            </div >

        </div >
    );
}


const mapStateToProps = state => {
    //  console.log(state)
    return {
        items: state._todoProduct
    }
}

export default connect(mapStateToProps, { SetId })(Content)

/*
  <div style={{ marginLeft: 6, marginTop: 4 }}>
                            <stripe-buy-button
                                buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                                publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
                            >
                            </stripe-buy-button>
                        </div>


*/